// extracted by mini-css-extract-plugin
export default {"container":"hotelCardAvailability-module__container__szvZe","compactContainer":"hotelCardAvailability-module__compactContainer__KBj4W"};